<div class="border border-sky-500 rounded-xl p-5 flex flex-col h-full">
    <div class="flex items-start gap-3 mb-4">
        <div class="flex h-14 w-14 items-center justify-center rounded-full bg-sky-800 text-white font-semibold">
            {{ requerimientos.label }}
        </div>
        <div class="flex-1 gap-4">
            <p class="text-md flex-1 mb-6">
                {{requerimientos.descripcion}}
            </p>
            <div class="flex flex-col text-md font-semibold tracking-wide leading-relaxed mb-4 uppercase">
               @for(p of palabras; track p){
                    <span>
                        -{{p}}
                    </span>
               }
            </div>

            <p class="mt-auto text-md">
                {{requerimientos.requisitos}}
            </p>
        </div>

    </div>
</div>
